<div class="row mt-4">
  <div class="col-12">
    <h1>{{ title }}</h1>
  </div>

  <ng-container [ngTemplateOutlet]="linksTemplate"></ng-container>
</div>
